<template>

    <div v-if="!paymentModal" class="price__heading">
        <div class="price__heading-box mb">
            <BackButton class="back-button"/>
            <h2 class="mb0 h1">{{ $t('general.buy_credits') }}</h2>
        </div>

        <h4 class="mb- clr-gold"><strong>{{$t('payment.attention')}}</strong></h4>
        <p class="mb">{{themeT('payment.start')}}</p>
        <p class="mb0">{{ $t(`credits.only`) }} {{ conversation_price }} {{ $t('credits.credits') }}
                {{ $t('credits.to_unlock_conversation') }} <strong class="clr-gold">{{ $t('credits.then_all') }}</strong></p>

    </div>

    <div v-else>
        <div class="amount-box">
            <img src="../../assets/img/dollar-icon.svg" alt="Dollar icon"> {{credits}}
        </div>
        <h2 class="h4">{{$t('credits.not_enough_credits')}}? {{$t('credits.recharge')}}:</h2>
    </div>
</template>

<script>
import BackButton from "@/components/generic/BackButton.vue";
import ThemeMixin from "@/mixins/ThemeMixin";
import { mapState } from "vuex";
export default {
    name: "DefaultPromotionHeader",
    components: { BackButton },
    mixins: [ThemeMixin],
    props: {
        promotion: {
            type: Object
        },
        paymentModal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            credits: state => state.credits.amount
        })
    },
    data() {
        return {
            cityChatAvatars: [],
            cityChatUnlockedCount: 47,
            cityChatRefreshTimer: null
        }
    },
    created() {
        this.conversation_price = process.env.VUE_APP_UNLOCK_CONVERSATION
        this.refreshCityChatUnlocks()
    },
    mounted() {
        this.scheduleCityChatRefresh()
    },
    beforeUnmount() {
        clearTimeout(this.cityChatRefreshTimer)
    },
    methods: {
        refreshCityChatUnlocks() {
            const seed = this.getDailySeed()
            const rng = this.createSeededRandom(seed)
            const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
            const shuffled = [...alphabet]

            for (let i = shuffled.length - 1; i > 0; i -= 1) {
                const j = Math.floor(rng() * (i + 1))
                const temp = shuffled[i]
                shuffled[i] = shuffled[j]
                shuffled[j] = temp
            }

            this.cityChatAvatars = shuffled.slice(0, 4)
            this.cityChatUnlockedCount = 40 + Math.floor(rng() * 161)
        },
        scheduleCityChatRefresh() {
            const now = new Date()
            const nextMidnight = new Date(now)
            nextMidnight.setHours(24, 0, 0, 0)

            clearTimeout(this.cityChatRefreshTimer)
            this.cityChatRefreshTimer = setTimeout(() => {
                this.refreshCityChatUnlocks()
                this.scheduleCityChatRefresh()
            }, nextMidnight.getTime() - now.getTime())
        },
        getDailySeed() {
            const now = new Date()
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')

            return `${year}-${month}-${day}`
        },
        createSeededRandom(seed) {
            let h = 2166136261

            for (let i = 0; i < seed.length; i += 1) {
                h ^= seed.charCodeAt(i)
                h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24)
            }

            return () => {
                h += h << 13
                h ^= h >>> 7
                h += h << 3
                h ^= h >>> 17
                h += h << 5

                return ((h >>> 0) % 1000000) / 1000000
            }
        }
    }
}

</script>
<style scoped lang="scss">

    .promotion-benefits {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        column-gap: 24px;
        row-gap: 14px;
        width: 100%;
        margin: 0;
        padding: 14px 16px;
        list-style: none;
    }

    .promotion-benefits__item {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.3;
        white-space: nowrap;
    }

    .promotion-benefits__check {
        color: #0f5f34;
        font-size: 15px;
        font-weight: 700;
        line-height: 1;
    }

    .promotion-benefits__lock {
        font-size: 15px;
        line-height: 1;
    }

    @media (max-width: 420px) {
        .promotion-benefits {
            column-gap: 16px;
            padding-inline: 12px;
        }

        .promotion-benefits__item {
            font-size: 12px;
        }
    }

    .price__heading {
        text-align: left;

        h2 {
            margin-bottom: 10px;
            font-weight: 700;
            line-height: 1.3;
            color: $color-credits-type4;
        }

        p {
            font-size: 18px;
            line-height: 1.4;
            color: $color-credits-type3;
        }
        
        .sub-heading {
            color: $color-credits-type3;
        }

        @media(max-width: 991px) {
            padding: 0 20px;

            p {
                margin-bottom: 0;
                font-size: 16px;
                line-height: 19px;
                letter-spacing: 0.06px;
            }
        }

        @media(max-width: 768px) {
            .sub-heading br {
                display: none;
            }
        }
    }

    .paragraph-box {
        text-align: left;
        border-radius: 10px; 
        padding: 15px 20px;
        // box-shadow: 0px 0px 12px -3px #bebebe;
        border: 1px solid #bebebe;
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 20px;
        background: $color-credits-gradient1;

        .icon {
            min-width: 40px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: rgba($color-credits-type1, .18);
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                stroke: $color-credits-type1;
            }
        }

        p {
            color: $color-credits-type2;
            font-size: 14px;
        }

        @media(max-width: 991px) {
            margin-bottom: 20px;
            align-items: flex-start;
            gap: 10px;
        }
    }

    .price__heading-box {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .back-button {
            margin-right: 20px;
            display: none;
        }

        @media(max-width: 991px) {
            margin-bottom: 25px;

            .back-button {
                display: flex;
            }
        }
    }

    .amount-box {
        border-radius: 15px;
        background-color: #fff;
        padding-left: 40px;
        position: relative;
        display: inline-flex;
        align-items: center;
        font-weight: 700;
        height: 30px;
        width: auto;
        padding-right: 20px;
        margin-bottom: 10px;
        font-size: 18px;
        font-family: "Open Sans", sans-serif!important;

        img {
            position: absolute;
            top: 0;
            left: 0;
        }

        @media(max-width: 350px) {
            min-width: 105px;
        }
    }
</style>
